/*-----------------------------------------------------------------
- About
-----------------------------------------------------------------*/
export default {
    title: 'About us',

    team_title: 'Ekipten haber alın',

    career: {
        title  : 'We Are Hiring!',
        tab_all: 'All',
        index  : '({0})',
        button : 'Apply now',
        empty  : 'No career has been found',
    },

    case: {
        title : 'Related Case Studies',
        button: 'View Case Studies',
    },
};
